<template>
    <layout-o-auth-2>
        <p style="color: white;
    margin-top: 21px;">
            Authentication...
        </p>

    </layout-o-auth-2>
</template>

<script>

import LayoutOAuth2 from '@/layouts/LayoutOAuth2'
import axios from 'axios'

export default {
  name: 'OAuth2Callback',
  components: {
    LayoutOAuth2
  },
  methods: {
    getAccessToken: function () {
      if (window.opener) {
        axios.post(this.cpAuth.accessTokenUrl, {
          code: this.getCode(),
          client_id: this.cpAuth.clientId,
          client_secret: this.cpAuth.clientSecret,
          redirect_uri: this.cpAuth.redirectUrl,
          grant_type: 'authorization_code'
        }, { 'headers': {
          'Authorization': 'Bearer 123',
          'Content-Type': 'application/json'
        } })
          .then(function (response) {
            window.opener.postMessage(JSON.stringify(response.data), '*')
            window.close()
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getCode: function () {
      var href = window.location.href
      var url = new URL(href)
      return url.searchParams.get('code')
    }
  },

  created: function () {
    this.getAccessToken()
  },

  data () {
    return {
      backendVersions: {},
      frontendVersions: {},
      isLoading: false
    }
  }
}
</script>
